import { Component, Vue,Prop } from 'vue-property-decorator';
import WithRender from  './WalletTransactions.html';
import config from "@/settings/config.js";
import { WalletTransactionsDto } from './WalletTransactionsDto';
import _axios from '@/services/axios';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { mapGetters } from 'vuex';

@WithRender
@Component({
  components: {
    Loading,
  },
  computed: {
    ...mapGetters("originatorStore", {currency:"getWalletCurrency"}),
  }
})
export default class WalletTransactions extends Vue {
  currency!: string;
  isLoading = true;

 public walletTransactionsDto: WalletTransactionsDto[]=[];
   
   mounted () {
   this.getCreditBalance();
  }
 getCreditBalance():void
    {
     this.isLoading = true
      _axios.get(config.walletTransactions+`Currency=${this.currency}`).then(response=>
            {
              this.mapOutTransactions(response.data);
            }).catch(err=>{
                console.error(err);
              })
              .finally(() => {
                this.isLoading = false;
              });
    }

  private mapOutTransactions(value:WalletTransactionsDto)
  {
    this.walletTransactionsDto.push(value);
  }

}
